import React from 'react';
import { Container, Header, Grid, Card, Divider } from 'semantic-ui-react';
import '../public/css/About.css';

const About = () => (
	<Container className="about-container">
		<Divider hidden />
		<Header as="h1" textAlign="center" className="about-header">
			About
		</Header>
		<Divider hidden />
		<Grid divided="vertically" stackable centered>
			<Grid.Row columns={1}>
				<Grid.Column width={12}>
					<Card fluid color="yellow" className="about-card">
						<Card.Content>
							<Card.Description>
								<span className="text-keyword">The Persian Tadhkira Project</span> is devoted to
								exploring trends in the production and circulation of{' '}
								<span className="text-keyword">tadhkiras</span> (biographical anthologies) of Persian
								poets produced across the Persianate world from 1200-1900. Its major aim is to
								understand how macro-level trends in the production and circulation of this particular
								genre can help elucidate shifting levels of transregional interconnectivity in the
								Persianate world across space and time. For an introduction to this topic and the
								methodological approach see Kevin L. Schwartz, “A Transregional Persianate Library: The
								Production and Circulation of <span className="text-keyword">tadhkiras</span> of Persian
								Poets in the 18th and 19th Centuries,”
								<span className="text-link">
									<a
										href="https://www.cambridge.org/core/journals/international-journal-of-middle-east-studies/article/abs/transregional-persianate-library-the-production-and-circulation-of-tadhkiras-of-persian-poets-in-the-18th-and-19th-centuries/5552050DC6504E53C7AE05FDE65EB3CD"
										target="_blank"
										rel="noopener noreferrer"
									>
										International Journal of Middle East Studies
									</a>
								</span>{' '}
								, 52.1 (2020): pp. 109-135.
							</Card.Description>
						</Card.Content>
					</Card>
					<Divider hidden />
					<Card fluid color="orange" className="about-card">
						<Card.Content>
							<Card.Description>
								<p>
									The research for this project has been partially funded by a Social Science Research
									Council Postdoctoral Fellowship for Transregional Research with funds provided by
									the Andrew W. Mellon Foundation, the John W. Kluge Center at the US Library of
									Congress, and the Czech Academy of Sciences Strategy AV21 program “Memory in the
									Digital Age.”
								</p>
								<p>
									This site was designed by{' '}
									<span className="text-link">
										<a href="https://daoyidh.com/" target="_blank" rel="noopener noreferrer">
											DaoYi Technology Ltd
										</a>
									</span>
									.
								</p>
							</Card.Description>
						</Card.Content>
					</Card>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	</Container>
);

export default About;
